import { refreshPage } from "../index";

// Toggle between News/Events
export function newsEventsToggle() {
  if (document.querySelector(".m-news-events__toggle")) {
    const body = document.body;
    const newsButton = document.querySelector(".news-button");
    const eventsButton = document.querySelector(".events-button");
    const filterResultsContainer = document.querySelector(
      ".filter-results-container",
    );
    const filterResultsNews = document.querySelector(".filter-results--news");
    const filterResultsEvents = document.querySelector(
      ".filter-results--events",
    );

    function filterResultsHeight() {
      const selectedToggle =
        localStorage.getItem("selectedToggleNews") ||
        localStorage.getItem("selectedToggleEvents");
      if (selectedToggle) {
        body.classList.add(selectedToggle);
        if (selectedToggle === "news-toggle-open") {
          // Set the height of filter-results-container to match filter-results--news if news-toggle-open is selected
          filterResultsContainer.style.height =
            filterResultsNews.offsetHeight + "px";
        } else if (selectedToggle === "events-toggle-open") {
          // Set the height of filter-results-container to match filter-results--events if events-toggle-open is selected
          filterResultsContainer.style.height =
            filterResultsEvents.offsetHeight + "px";
        }
      }
    }

    function newsButtonClick() {
      body.classList.add("news-toggle-open");
      body.classList.remove("events-toggle-open");
      localStorage.setItem("selectedToggleNews", "news-toggle-open");
      localStorage.removeItem("selectedToggleEvents");
      filterResultsHeight();
      refreshPage();
    }

    function eventsButtonClick() {
      body.classList.add("events-toggle-open");
      body.classList.remove("news-toggle-open");
      localStorage.setItem("selectedToggleEvents", "events-toggle-open");
      localStorage.removeItem("selectedToggleNews");
      filterResultsHeight();
      refreshPage();
    }

    if (newsButton && eventsButton) {
      newsButton.addEventListener("click", newsButtonClick);
      eventsButton.addEventListener("click", eventsButtonClick);
    } else if (localStorage.getItem("selectedToggleEvents")) {
      newsButtonClick();
    }

    // Retrieve the selected class from localStorage and set the filter results height when the page is loaded
    filterResultsHeight();
  }
}

// Set classes and localStorage to events
export function newsEventsSet() {
  if (document.querySelector(".type-teaser-events")) {
    const body = document.body;
    const teaserEventsButton = document.querySelector(
      ".type-teaser-events .button-view-all",
    );

    function teaserEventsButtonClick() {
      body.classList.add("events-toggle-open");
      body.classList.remove("news-toggle-open");
      localStorage.setItem("selectedToggleEvents", "events-toggle-open");
      localStorage.removeItem("selectedToggleNews");
    }

    teaserEventsButton.addEventListener("click", teaserEventsButtonClick);
  }
}

// Set filter results height when the window is resized
export function newsEventsScale() {
  if (document.querySelector(".m-news-events__toggle")) {
    const filterResultsContainer = document.querySelector(
      ".filter-results-container",
    );
    const filterResultsNews = document.querySelector(".filter-results--news");
    const filterResultsEvents = document.querySelector(
      ".filter-results--events",
    );

    const selectedToggle =
      localStorage.getItem("selectedToggleNews") ||
      localStorage.getItem("selectedToggleEvents");
    if (selectedToggle) {
      if (selectedToggle === "news-toggle-open") {
        // Set the height of filter-results-container to match filter-results--news if news-toggle-open is selected
        filterResultsContainer.style.height =
          filterResultsNews.offsetHeight + "px";
      } else if (selectedToggle === "events-toggle-open") {
        // Set the height of filter-results-container to match filter-results--events if events-toggle-open is selected
        filterResultsContainer.style.height =
          filterResultsEvents.offsetHeight + "px";
      }
    } else {
      document.body.classList.add("news-toggle-open");
      // Set the height of filter-results-container to match filter-results--news if news-toggle-open is selected
      filterResultsContainer.style.height =
        filterResultsNews.offsetHeight + "px";
    }
  }
}
